import { call, put, takeEvery } from "redux-saga/effects";
// Constants
import { SUPPORT } from '../../Actions/Support/types';
import { loadSupportFaqSuccess, loadSupportFaqFailure,loadGeoIPCountrySuccess,fetchCountrySuccess, fetchCountryFailure,loadGeoIPCountryFailure, loadProductUpdateSuccess, loadProductUpdateFailure, loadUnauthenticatedSupportFaqSuccess, loadUnauthenticatedSupportFaqFailure} from '../../Actions/Support/supportActions';
import { getSupportFaq, productUpdateApi,getSupportCountries , getSupportUnauthenticatedFaq, getGeoIPCountry } from '../../Services/Support/supportApi';

// Saga handlers
export default function* supportSaga() {
  yield takeEvery(SUPPORT.LOAD_SUPPORT_FAQS, fetchFaqList);
  yield takeEvery(SUPPORT.LOAD_PRODUCT_UPDATE, fetchProductUpdateList);
  yield takeEvery(SUPPORT.LOAD_UNAUTHENTICATED_SUPPORT_FAQS, fetchUnauthenticatedFaqList);
  yield takeEvery(SUPPORT.LOAD_GEO_IP_COUNTRY, fetchGeoIPCountry);
  yield takeEvery(SUPPORT.LOAD_GET_COUNTRIES, fetchCountry);
}

export function* fetchFaqList() {
  try {
    let response = yield call(getSupportFaq);
     response.data.forEach((item)=>{
      item.data = JSON.parse(item.data)
      return item
    })
      if (response && response.status === 200 && response.data) {
      yield put(loadSupportFaqSuccess(response.data));
    }
  } catch (e) {
    yield put(loadSupportFaqFailure(e));
  }
}

export function* fetchUnauthenticatedFaqList() {
  try {
    let response = yield call(getSupportUnauthenticatedFaq);
    response.data.forEach((item)=>{
      item.data = JSON.parse(item.data)
      return item
    })    

      if (response && response.status === 200 && response.data) {
      yield put(loadUnauthenticatedSupportFaqSuccess(response.data));
        
    }
  } catch (e) {
    yield put(loadUnauthenticatedSupportFaqFailure(e));
  }
}

export function* fetchGeoIPCountry() {
  try {
    let response = yield call(getGeoIPCountry);
      if (response && response.status === 200 && response.data) {
      yield put(loadGeoIPCountrySuccess(response.data));
    }
  } catch (e) {
    yield put(loadGeoIPCountryFailure(e));
  }
}
export function* fetchCountry() {
  try {
    let response = yield call(getSupportCountries);
    let currentCountry = yield call(getGeoIPCountry);
    let localCountry = localStorage.getItem('activeCountry');
    let responseCountries = response.data.sort();
    let country = currentCountry.data.data.countryCode;
    let curCountry = "";
  
    if (localCountry !== 'NaN' && localCountry !== null) {
      const isQBC = localCountry.indexOf('QBC') !== -1;
      const countryCodeLength = isQBC ? 3 : 2;
      const languageCodeLength = isQBC ? 2 : 5;
    
      curCountry = responseCountries.filter((item) => {
        return (
          item.countryCode === localCountry.substring(0, countryCodeLength) &&
          item.languageCode === localCountry.substring(countryCodeLength, countryCodeLength + languageCodeLength)
        );
      });
    }
    else
    {
      curCountry = responseCountries
        .filter((item) => {
        return item.countryCode == country;
      });
    }
    
    if(curCountry.length != 0){
      localStorage.setItem("activeCountry", curCountry[0].countryCode + curCountry[0].languageCode )
      localStorage.setItem("activeLanguageCountry", curCountry[0].languageName +"/"+ curCountry[0].countryCode)
    }
    else
    {
      curCountry = "US";
      localStorage.setItem("activeCountry", curCountry + 'en_US' )
      localStorage.setItem("activeLanguageCountry", "English" +"/"+ curCountry)
    }
    
    let list = response.data
    list.sort((a, b) => (a.countryCode > b.countryCode) ? 1 : -1)
    if (response && response.status === 200 && response.data) {
        yield put(fetchCountrySuccess(response.data));
    }
  } catch (e) {
    yield put(fetchCountryFailure(e));
  }
}

export function* fetchProductUpdateList(data) {
  let { language } = data;
  try {
    let response = yield call(productUpdateApi, language);
    
    if (response && response.status === 200 && response.data) {
      let a = response.data;
      let newList = a.map((i) => {
        if (i.id === 1) {
          return {
            open: true,
            ...i
          }
        } else {
          return {
            open: false,
            ...i
          }
        }
      })
      // .sort((c, b) => c.id < b.id ? -1 : 1)
      yield put(loadProductUpdateSuccess(newList));
    }
  } catch (e) {
    yield put(loadProductUpdateFailure(e));
  }
}